import { Grid2, IconButton, Typography } from "@mui/material";
import { paletteLightTheme } from "utils/ColorTheme";
import { DownloadIcon } from "./Icons";

interface Props {
  index: number;
  data: {
    id: number;
    file: string;
    visible: boolean;
    uploadedBy: string;
    name: string;
    createdOn: string;
  };
  size?: string;
}

const GKFilePreviewCard = ({ index, data }: Props) => {
  return (
    <Grid2
      p={1}
      container
      key={index}
      borderRadius={2}
      spacing={2}
      border={`1px solid var(--neutral-100)`}
      my={1}
    >
      <Grid2 size={10} display={"flex"} alignItems={"center"} gap={1}>
        <img
          src={`/FileIcons/${data?.name?.split(".").pop()}.svg`}
          height={20}
          width={20}
          alt=""
          style={{
            borderRadius: 4,
            border: "1px solid",
            borderColor: paletteLightTheme.palette.border.main,
            padding: 4,
          }}
        />
        <Typography
          fontSize={10}
          fontWeight={600}
          textAlign={"left"}
          textOverflow={"ellipsis"}
          overflow={"hidden"}
          whiteSpace={"nowrap"}
        >
          {data?.name}
        </Typography>
      </Grid2>
      <Grid2 size={2}>
        <IconButton href={data?.file} target="__blank">
          <DownloadIcon />
        </IconButton>
      </Grid2>
    </Grid2>
  );
};

export default GKFilePreviewCard;
